import styled from '@emotion/styled'

import media from '../../../common/MediaQueries'

export const GatsbyImgStyled = styled.div`
  max-width: 100%;
  @media ${media.maxTablet} {
    .gatsby-image-wrapper {
      height: 100% !important;
    }
  }
`

export const StaticImageFigureStyled = styled.figure`
  display: flex;
  line-height: 1em;

  .lazy-load-image-background {
    img {
      max-width: 100%;
      height: auto;
    }
  }
`

export const StaticImagePlaceholderStyled = styled.div`
  width: 100%;
  height: 100%;
`
